<template lang="pug">
    .container.mx-auto.spacingTopStandard.spacingBottomStandard
      table.table.table-auto
        tbody
          tr
            td(width='163')
              strong Bordeaux
            td(width='125')
            td(width='171')
          tr
            td
              strong Name
            td
              strong Inhalt
            td
              strong # Bordeaux Flaschen
          tr
            td Half
            td 375 ml
            td 1/2 Bottle
          tr
            td Bottle
            td 750 ml
            td 1 Bottle
          tr
            td Magnum
            td 1500 ml (1.5 L)
            td 2 Bottles
          tr
            td Marie Jeanne
            td 2250 ml (2.25 L)
            td 3 Bottles
          tr
            td Double Magnum
            td 3000 ml (3 L)
            td 4 Bottles
          tr
            td Jeroboam
            td 5000 ml (5 L)
            td 6 Bottles
          tr
            td Imperial
            td 6000 ml (6 L)
            td 8 Bottles
          tr
            td Balthazar
            td 12000 ml (12 L)
            td 16 Bottles
          tr
            td Nebuchadnezzar
            td 15000 ml (15 L)
            td 20 Bottles
          tr
            td Melchior
            td 18000 ml (18 L)
            td 24 Bottles
          tr
            td
              strong Burgund / Rhone
            td
            td
          tr
            td
              strong Name
            td
              strong Inhalt
            td
              strong # Burgunder Flaschen
          tr
            td Half
            td 375 ml
            td 1/2 Bottle
          tr
            td Bottle
            td 750 ml
            td 1 Bottle
          tr
            td Magnum
            td 1500 ml (1.5 L)
            td 2 Bottles
          tr
            td Jeroboam
            td 3000 ml (3 L)
            td 4 Bottles
          tr
            td Rehoboam
            td 4500 ml (4.5 L)
            td 6 Bottles
          tr
            td Methuselah
            td 6000 ml (6 L)
            td 8 Bottles
          tr
            td Salmanazar
            td 9000 ml (9 L)
            td 12 Bottles
          tr
            td Balthazar
            td 12000 ml (12 L)
            td 16 Bottles
          tr
            td Nebuchadnezzar
            td 15000 ml (15 L)
            td 20 Bottles
          tr
            td Melchior
            td 18000 ml (18 L)
            td 24 Bottles
          tr
            td
              strong CHAMPAGNE
            td
            td
          tr
            td
              strong Name
            td
              strong Inhalt
            td
              strong # Champagner Flaschen
          tr
            td Half
            td 375 ml
            td 1/2 Bottle
          tr
            td Bottle
            td 750 ml
            td 1 Bottle
          tr
            td Magnum
            td 1500 ml (1.5 L)
            td 2 Bottles
          tr
            td Jeroboam
            td 3000 ml (3 L)
            td 4 Bottles
          tr
            td Rehoboam
            td 4500 ml (4.5 L)
            td 6 bottles
          tr
            td Methuselah
            td 6000 ml (6 L)
            td 8 bottles
          tr
            td Salmanazar
            td 9000 ml (9 L)
            td 12 Bottles
          tr
            td Balthazar
            td 12000 ml (12 L)
            td 16 Bottles
          tr
            td Nebuchadnezzar
            td 15000 ml (15 L)
            td 20 Bottles
          tr
            td Melchior
            td 18000 ml (18 L)
            td 24 Bottles


</template>

<script>
export default {
    name: 'Table5'
    // Flaschengrößen und Flaschenformen
};
</script>

<style lang="sass" scoped>
.table
  @apply table w-full

  tr:nth-child(odd)
    @apply bg-gray-100

  &:first-child
    td
    @apply border-t
  td, th
    @apply border-b border-r
    padding: 6px 10px
    &:first-child
      @apply border-l
</style>
